import { STORAGE_KEYS } from 'constants/storageKeys';
import { ThemeConfig } from 'types/storefront';
import { tenantStorage } from 'utils/tenantStorage';

const isThemeConfig = (value: unknown): value is ThemeConfig =>
  !!value && typeof value === 'object' && !Array.isArray(value);

/** Última apariencia conocida, para pintarla antes de que responda el API. */
export const readCachedTheme = (): ThemeConfig | null => {
  try {
    const raw = tenantStorage.getItem(STORAGE_KEYS.THEME);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return isThemeConfig(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const writeCachedTheme = (theme: ThemeConfig): void => {
  try {
    tenantStorage.setItem(STORAGE_KEYS.THEME, JSON.stringify(theme));
  } catch {
    // localStorage lleno o bloqueado: el tema igual se aplica en esta visita.
  }
};

export const applyCachedThemeToDocument = (theme: ThemeConfig | null): void => {
  const siteName = theme?.siteName?.trim();
  if (siteName) document.title = siteName;

  const primaryColor = theme?.primaryColor?.trim();
  if (!primaryColor) return;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = primaryColor;
};
